<template>

	<div
			class="y-modal is_record y-practice__modal-record"
			data-modal="record"
			ref="addWorkingPeriodModal"
	>
		<div class="y-modal__inner">
			<div class="y-modal__header">
				<div class="y-modal__title">{{ $t('Book_making_lesson') }}</div>
				<button
						data-modal-close
						class="y-btn y-modal__btn-close"
						aria-label="close modal record"
				>
					<span class="y-btn__icn"></span>
					<span class="y-btn__txt">закрыть</span>
				</button>
			</div>
			<div class="y-modal__main" data-scroll-check>
				<div class="y-modal__main-inner" data-scroll-inner>

					<div class="y-record" v-for="(cell, index) in cells">

						<div class="y-record__row" >
							<div class="y-record__key">{{ $t('Date') }}</div>
							<div class="y-record__val">
								{{  new Intl.DateTimeFormat('uk-UA', { weekday: 'long' }).format(new Date(cell.day)) }},
								{{  new Intl.DateTimeFormat('uk-UA', { day: 'numeric' }).format(new Date(cell.day)) }}
								{{  new Intl.DateTimeFormat('uk-UA', { month: 'long' }).format(new Date(cell.day)) }}
							</div>
						</div>

						<div class="y-record__row">
							<div class="y-record__key">{{ $t('Time') }}</div>
							<div class="y-record__val">
								<span class="y-record__time">{{ cell.start }}</span>
								<span>-</span>
								<span class="y-record__time">{{ cell.end }}</span>
							</div>
						</div>

						<div
								:class="{'has-danger': errors.has(`cells.${index}.type`, 'StPrAdPMo')}"
								class="y-record__row is_col"
						>
							<div class="y-record__key">{{ $t('Format') }}</div>
							<div class="y-record__val">
								<multiselect
										v-model="cell.type"
										placeholder="Select type"
										:options="types"
										label="name"
										@close="forceUpdate"
										@input="forceUpdate"
								>
								</multiselect>
							</div>
							<div v-if="errors.has(`cells.${index}.program`, 'StPrAdPMo')"
									 class="y-record__error" v-cloak>
								{{ errors.first(`cells.${ index }.program`, 'StPrAdPMo') }}
							</div>
						</div>

						<div
								v-if="absents.programs.length >= 1"
								:class="{'has-danger': errors.has(`cells.${index}.program`, 'StPrAdPMo')}"
								class="y-record__row is_col"
						>
							<div class="y-record__key">{{ $t('Program') }}</div>
							<div class="y-record__val">
								<multiselect
										v-model="cell.program"
										placeholder="Select program"
										label="name"
										:options="absents.programs"
										:multiple="false"
										@input="removeLesson(index)"
								>
								</multiselect>
							</div>
							<div v-if="errors.has(`cells.${index}.program`, 'StPrAdPMo')"
									 class="y-record__error" v-cloak>
								{{ errors.first(`cells.${ index }.program`, 'StPrAdPMo') }}
							</div>
						</div>

						<div class="y-record__row is_col" :class="{'has-danger': errors.has(`cells.${index}.lesson`, 'StPrAdPMo')}">
							<div class="y-record__key">{{ $t('class_missed') }}</div>
							<div class="y-record__val">
								<multiselect
										v-model="cell.lesson"
										placeholder="Select lesson"
										label="name"
										:options="absents.absents[cell.program.id]"
										:multiple="false"
										@close="forceUpdate"
								>
								</multiselect>
							</div>
							<div v-if="errors.has(`cells.${index}.lesson`, 'StPrAdPMo')"
									 class="y-record__error" v-cloak>
								{{ errors.first(`cells.${ index }.lesson`, 'StPrAdPMo') }}
							</div>
						</div>

						<div class="y-record__row is_col" :class="{'has-danger': errors.has(`cells.${index}.phone`, 'StPrAdPMo')}">
							<div class="y-record__key">{{ $t('Phone') }}</div>
							<div class="y-record__val" style="display: block; line-height: 47px;">
								<div class="multiselect__input">
									<div class="multiselect__tags">
										<input class="multiselect__input"
											style="padding: 0px 15px !important"
											type="text"
											v-model="cell.phone"
											@close="forceUpdate"
										>
									</div>
								</div>
							</div>
							<div v-if="errors.has(`cells.${index}.lesson`, 'StPrAdPMo')"
									 class="y-record__error" v-cloak>
								{{ errors.first(`cells.${ index }.lesson`, 'StPrAdPMo') }}
							</div>
						</div>

					</div>

				</div>
			</div>
			<div class="y-modal__footer">
				<div class="elms jcsb cg-10">
					<button
							type="button"
							:disabled="submiting"
							@click="savePeriod"
							class="y-btn y-btn_main y-record__btn-main"
					>
						<span class="y-btn__txt">{{ $t('Save') }}</span>
					</button>
					<button
							type="button"
							@click="cancel()"
							data-modal-close
							class="y-btn y-btn_default y-record__btn-default"
					>
						<span class="y-btn__icn">{{ $t('Close') }}</span>
					</button>
				</div>

			</div>

		</div>
	</div>

</template>

<script>

import axios from "axios";

export default {
	name: "StudentPracticeAddPeriodModal",
	props: [ 'data_cells', 'data_absents' ],
	data() {
		return {
			submiting: false,
			tutor: null,
			programs: [],
			lessons: [],
			types: [
				{ value: 'online', name: this.$t('online_class') },
				{ value: 'offline', name: this.$t('offline_class') }
			],
			program: null,
			lesson: null,
			absents: null,
			week: null,
			table: null,
			days: null,
			cells: [],
			datetimePickerConfig: {
				enableMonth: true,
				altFormat: "Y-m-d",
				dateFormat: "Y-m-d",
				locale: { firstDayOfWeek: 1 },
				disable: [
					function (date) {
						return ([ 0, 2, 3, 4, 5, 6 ].includes(date.getDay()));
					}
				],
				onClose: (selectedDates, dateStr, instance) => {
					this.getShedule(instance);
				},
			},
		}
	},
	mounted() {
		this.BtnDisabled = this.btn_disabled;
		this.cells = this.data_cells;
		this.absents = this.data_absents;
		if (this.absents.programs.length >= 1) {
			this.cells.forEach((item, index) => {
				this.cells[index].program = this.absents.programs[0];
			})
		}
		this.cells.forEach((item, index) => {
			this.cells[index].type = this.types[0];
			this.cells[index].phone = item.phone || this.$parent.student.student_description.phone;
		})

		$(document).on('click', '.y-modal.is_record [data-modal-close], [data-modal-close].is_record', () => {

			$(`[data-modal]`).on('transitionend webkitTransitionEnd oTransitionEnd', () => {
				$('[data-overlay]').on('transitionend webkitTransitionEnd oTransitionEnd', () => {
					this.$parent.show_modal_add_period = false
					this.cells = [];
					this.$parent.choose_data = [];
					$(`.is_record [data-modal]`).off('transitionend webkitTransitionEnd oTransitionEnd')
				})
			})
		})

	},
	methods: {
		async savePeriod() {
			this.submiting = true;
			let post_data = {
				cells: this.cells,
				academy: this.$parent.academy,
				tutor: this.$parent.tutor,
				student: this.$parent.student,
				group: this.$parent.group,
			};
			try {
				await axios.post('practice/savePeriod', post_data);
				this.$parent.getShedule();
				this.$parent.getAbsents();
				this.cancel();
			} catch (error) {
				this.errors.clear('StPrAdPMo');
				let errors = error.response.data.errors;
				for (const prop in errors) {
					this.errors.add({ field: prop, msg: errors[prop][0], scope: 'StPrAdPMo' });
				}
			}
			this.submiting = false;
		},

		getEndPeriod(start) {
			const myarr = start.split(":");
			let end;
			const hour = parseInt(myarr[0]);
			if (myarr[1] === "20") {
				end = [ hour, "40" ].join(':')
			} else if (myarr[1] === "00") {
				end = [ hour, "20" ].join(':')
			} else {
				end = [ hour + 1, "00" ].join(':')
			}
			return end;
		},
		removeLesson(index) {
			this.cells[index].lesson = null;
		},
		cancel() {
			$('.is_record [data-modal-close]').trigger('click')
			this.$emit('closePracticeModal')

		},
		forceUpdate() {
			this.$forceUpdate();
		}
	}
}
</script>
